export default "__VITE_ASSET__DZZWrZ0p__"